import request from '@/utils/request'
// 获取语音列表
const getSmsList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg/list`,
        params:{
            ...params,
            type: 'VMS'
        },
        method: 'get'
    })
}
// 获取语音列表数量
const getSmsListCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/count`,
        params:{
            ...params,
            type: 'VMS'
        },
        method: 'get'
    })
}
// 获取语音记录
const getSmsRecordList = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record`,
        params:{
            ...params,
            type: 'VMS'
        },
        method: 'get'
    })
}
// 获取语音记录数量
const getSmsRecordCount = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/count`,
        params:{
            ...params,
            type: 'VMS'
        },
        method: 'get'
    })
}
// 获取语音模板内容
const getSmsTemplate = (id) => {
    return request({
        url: `/gathering/meeting/${id}/msg/tmpl/list`,
        method: 'get'
    })
}
// 重新发送/批量发送
const againSend = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/send`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    })
}
// 获取当前用户的手机号
const getUserPhones = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg-record/phones`,
        method: 'get',
        params:{
            ...params,
            type: 'VMS'
        }
    })
}
// 语音群发
const groupSMS = (meetingId, id) => {
    return request({
        url: `/gathering/meeting/${meetingId}/msg/${id}/sendAll`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    })
}
// 单条语音发送
const singleSMS = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/msg/send`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    })
}
// 编辑语音通知
const editSMS = (meetingId, id, params) => {
    return request({
        url: `/gathering/meeting/${meetingId}/msg/${id}`,
        method: 'put',
        data: {
            ...params,
            type: 'VMS'
        }
    })
}
// 获取会议管理人
const getMeetingManager = (id) => {
    return request({
        url: `/gathering/meeting/${id}/manager`,
        method: 'get'
    })
}
// 获取excel文件手机号码
const getPhonesExcel = (meetingId,fileId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/lianlu_msg/get_phones_excel/${fileId}`,
        method: 'get'
    })
}
// 上传excel文件手机号码
const uploadPhonesExcel = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/lianlu_msg/get_phones_excel`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    });
}
// 发送自定义语音
const createNormalTask = (id, params) => {
    return request({
        url: `/gathering/meeting/${id}/lianlu_msg/create_normal_task`,
        method: 'post',
        data: params
    });
}
// 发送模板语音
const createTmplMsgTask = (meeting_id, params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/create_tmpl_msg_task`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    });
}
// 获取会议语音模板
const getMeetingLianluMsg = (meetingId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/lianlu_msg/get_meeting_lianlu_msg?type=VMS`,
        method: 'get'
    })
}
// 修改配置参数
const setLianluMsgParamJson = (meeting_id, meeting_lianlu_msg_id, params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/${meeting_lianlu_msg_id}/set_lianlu_msg_param_json`,
        method: 'post',
        data: {
            ...params,
            type: 'VMS'
        }
    })
}
// 获取新语音列表
const getTaskList = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_list`,
        method: 'get',
		params:{
            ...params,
            type: 'VMS'
        }
    })
}
// 获取新语音列表数量
const getTaskListCount = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_list_count`,
        method: 'get',
		params:{
            ...params,
            type: 'VMS'
        }
    })
}
// 获取语音任务详情列表
const getTaskDetailsList = (meeting_id,task_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_list/${task_id}`,
        method: 'get',
		params:{
            ...params,
            type: 'VMS'
        }
    })
}
// 获取语音任务详情列表
const getTaskDetailsListCount = (meeting_id,task_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_list_count/${task_id}`,
		params:{
            ...params,
            type: 'VMS'
        },
        method: 'get',
		
    })
}

// 获取语音任务详情统计数量
const getTaskDetailsStatistics = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/get_task_details_statistics`,
        method: 'get',
		params
    })
}
// 重发
const lianluMsgResend = (meeting_id,id) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/resend/${id}`,
        method: 'get',
    })
}
// 单发
const singleSend = (meeting_id,params) => {
    return request({
        url: `/gathering/meeting/${meeting_id}/lianlu_msg/single_send`,
		params,
        method: 'get',
    })
}
// 创建人工语音任务
const createTask = (id,params) => {
    return request({
        url: `/gathering/artificial_voice/${id}/create_task`,
        method: 'post',
		data: params
    })
}
// 删除人工语音任务
const delTask = (id) => {
    return request({
        url: `/gathering/artificial_voice/del_task/${id}`,
        method: 'delete'
    })
}
// 获取人工语音任务导出
const getTaskExport = (id,params) => {
    return request({
        url: `/gathering/artificial_voice/export/${id}`,
        method: 'get',
		params
    })
}
// 上传语音包
const uploadVoice = (id,params) => {
    return request({
        url: `/gathering/artificial_voice/upload_voice/${id}`,
        method: 'post',
		data: params
    })
}
// 删除语音包
const delVoice = (task_id,id) => {
    return request({
        url: `/gathering/artificial_voice/del_voice/${task_id}/${id}`,
        method: 'post',
    })
}
// 获取人工电话外呼任务列表
const getArtificialVoiceTaskList = (id,params) => {
    return request({
        url: `/gathering/artificial_voice/get_task_list/${id}`,
        method: 'get',
		params
    })
}
// 获取人工电话外呼任务列表数量
const getArtificialVoiceTaskListCount = (id,params) => {
    return request({
        url: `/gathering/artificial_voice/get_task_list_count/${id}`,
        method: 'get',
		params
    })
}
// 重置表决
const getResetVote = (vote_id,creditor_id,group_id) => {
    return request({
        url: `/gathering/vote/${vote_id}/report/${creditor_id}/${group_id}`,
        method: 'get',
    })
}

export {
    getSmsList,
    getSmsRecordList,
    getSmsTemplate,
    againSend,
    getSmsListCount,
    getSmsRecordCount,
    getUserPhones,
    getMeetingManager,
    groupSMS,
    singleSMS,
    editSMS,
	getPhonesExcel,
	uploadPhonesExcel,
	createNormalTask,
	getMeetingLianluMsg,
	setLianluMsgParamJson,
	createTmplMsgTask,
	getTaskList,
	getTaskListCount,
	getTaskDetailsList,
	getTaskDetailsListCount,
	getTaskDetailsStatistics,
	lianluMsgResend,
	singleSend,
	createTask,
	delTask,
	getTaskExport,
	uploadVoice,
	delVoice,
	getArtificialVoiceTaskList,
	getArtificialVoiceTaskListCount,
	getResetVote
}